import React from "react";

const Changeicon = ({ path }) => {
  return <img src={path} alt="change icon..." />;
};

export default Changeicon;
